
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.635 0a.455.455 0 00-.32.132L.223 4.225a.455.455 0 00-.132.32V16.82c0 .25.203.455.454.455h2.273v2.27c0 .252.204.456.456.456h12.272a.455.455 0 00.454-.455V3.183a.455.455 0 00-.454-.455h-2.274V.455a.455.455 0 00-.455-.454L4.635 0zm.455.909h7.273v15.455H1V4.999h3.636a.455.455 0 00.455-.454V.909zm-.909.645V4.09H1.645L4.18 1.554zm9.09 2.083h1.82V19.09H3.728v-1.817h9.09c.25 0 .454-.204.454-.455V3.638z"}}),_c('path',{attrs:{"d":"M7.364 4.09a.455.455 0 000 .91h2.728a.455.455 0 100-.91H7.364zM3.274 6.818a.455.455 0 000 .91h6.818a.455.455 0 100-.91H3.274zM3.274 9.545a.455.455 0 000 .91h6.818a.455.455 0 000-.91H3.274zM3.274 12.271a.455.455 0 000 .91H6a.455.455 0 100-.91H3.274z"}})])
          )
        }
      }
    